// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"65":"9673532d","303":"adb7b5a9","700":"6c832e46","853":"4ccae429","968":"5e85f563"}[chunkId] + ".css";
};